<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Contact Us</title>
</head>
<body>

  <nav class="navbar navbar-expand-lg fixed-top navbar-dark bg-dark">
  <div class="container-fluid">
    <a class="navbar-brand text-white" href="#">COSMO SPORTS</a>
    <button class="navbar-toggler" type="button" (click)="isCollapsed = !isCollapsed">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div [ngClass]="{'collapse navbar-collapse justify-content-end': true, 'show': !isCollapsed}" id="navbarNavDropdown">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a routerLink="/home-page" class="nav-link text-white" routerLinkActive="active">Home</a>
        </li>
        <li class="nav-item">
          <a routerLink="/about-us" class="nav-link text-white" routerLinkActive="active">About Us</a>
        </li>
        <li class="nav-item">
          <a routerLink="/contact-us" class="nav-link text-white" routerLinkActive="active">Contact</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<br>
<br><br>
<div class="d-block d-sm-none p-3">
  <div class="text-center">
    <img src="../../assets/img/home/cup12.jpg" alt="Notebook" class="img-fluid rounded mb-3" style="max-width: 280px; height: 250px;">
    
    <h1 class="text-primary mb-2">LOCATION</h1>
    <h4 class="fw-bold mb-3">
      COSMO SPORTS
      <sup><i class="fa fa-registered"></i></sup>
    </h4>

    <p class="mb-3">
      ECR ROUNDANA, East Coast Rd, Puthur,<br>
      Manjakollai, Nagapattinam,<br>
      Tamil Nadu 611106
    </p>

    <h5 class="text-primary mb-2">Phone | E-mail</h5>
    <p class="mb-1">
      <i class="fa fa-phone me-2"></i>
      <a class="text-decoration-none" href="tel:8056529291">8056529291</a>
    </p>
    <p class="mb-1">
      <i class="fa fa-phone me-2"></i>
      <a class="text-decoration-none" href="tel:9500706718">9500706718</a>
    </p>
    <p class="mb-1">
      For General Enquiries: 
      <a class="text-decoration-none" href="mailto:Cosmosports51@gmail.com">Cosmosports51@gmail.com</a>
    </p>
  </div>
</div>

  <div class="row1">
    <div class="col-lg-6 text-center w3-animate-left" style="padding-right: 0px;">
        <div class="contact-detail">
            <img src="../../assets/img/home/about.jpg" alt="Notebook" class="contact-img text-center">
            <div class="content p-4">
                <br /><br />
                <h1 class="text-light align-middle" style="color: white;">LOCATION</h1>
                <h4 class="align-middlefont-weight-bold">COSMO SPORTS
                    <sup >
                        <i class="fa fa-registered" aria-hidden="true"></i>
                    </sup>
                </h4>
                <p class="align-middle">
                 ECR ROUNDANA, East Coast Rd, Puthur,
                    <br />
                   Manjakollai, Nagapattinam,
                    <br />
             Tamil Nadu 611106
                </p>
                <h1 class="text-light">Phone | E-mail </h1>
                <p>
                  <span class="fa fa-phone" style="color: #ffffff; font-size: 25px;" aria-hidden="true"><a class="mail-call" href="tel:8056529291">&nbsp;&nbsp;&nbsp;&nbsp;8056529291</a></span>
                    <br />
                    <span class="fa fa-phone" style="color: #ffffff; font-size: 25px;" aria-hidden="true"><a class="mail-call" href="tel:9500706718">&nbsp;&nbsp;&nbsp;&nbsp;9500706718</a></span>
                    <br>
                    For General Enquiries: 
                    <a class="mail-call" href="mailto:Cosmosports51@gmail.com">Cosmosports51@gmail.com</a>
                    <br /><br>
                    <br />
                </p>
        </div>
    </div>
</div>
</div>
<br><br>
    <div class="container-fluid animatable bounceIn">
       <iframe src="https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d62715.27749290674!2d79.78282736860494!3d10.757215608063644!2m3!1f0!2f0!3
       f0!3m2!1i1024!2i768!4f13.1!4m13!3e6!4m5!1s0x3a556b753d640d91%3A0x5fe28840adb39127!2sCOSMO%20SPORTS%20TN-51%2C%20ECR%20ROUNDANA%2C%20East%20Coast%20Road%2C%20Puthur%
       2C%20Manjakollai%2C%20Nagapattinam%2C%20Tamil%20Nadu!3m2!1d10.757133999999999!2d79.824027!4m5!1s0x3a556b753d640d91%3A0x5fe28840adb39127!2sECR%20ROUNDANA%2C%20East%20Coast%20Rd%2C%20Put
       hur%2C%20Manjakollai%2C%20Nagapattinam%2C%20Tamil%20Nadu%20611106!3m2!1d10.757133999999999!2d79.824027!5e0!3m2!1sen!2sin!4v1759990783901!5m2!1sen!2sin" 
       width="100%" height="300" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>


    <section class="contact-section">
    <a href="tel:8056529291" class="contact-btn"><i class="fa fa-phone"></i> Call Now</a>
    <a href="mailto:info@cosmosports.com" class="contact-btn"><i class="fa fa-envelope"></i> Email Us</a>
    <a href="https://wa.me/8056529291" target="_blank" class="contact-btn"><i class="fa fa-whatsapp"></i> WhatsApp</a>
    <a href="https://www.instagram.com/cosmo_sports_51" target="_blank" class="contact-btn instagram-btn"><i class="fa fa-instagram"></i> Instagram</a>
  </section>
<!-- -------------------------------footer-------------------------- -->



<footer class="bg-dark pt-5 pb-3 mt-auto">
  <div class="container">
    <div class="row text-center text-md-start">

      <div class="col-md-4 mb-4 mb-md-0 text-center text-md-start">
        <img src="../../assets/img/home/cosmologo.jpg" alt="Sports Shop Logo" width="80" class="mb-3">
        <h5 class="text-white fw-bold">Gear Up for Your Game!</h5>
        <p class="text-white small">High-quality sports equipment and apparel for every athlete.</p>
      </div>

 
      <div class="col-md-4 mb-4 mb-md-0">
        <h5 class="text-white fw-bold">Quick Links</h5>
        <ul class="list-unstyled">
          <li><a routerLink="/" class="text-white text-decoration-none">Home</a></li>
          <li><a routerLink="/about-us" class="text-white text-decoration-none">About Us</a></li>
          <li><a routerLink="/contact-us" class="text-white text-decoration-none">Contact Us</a></li>
        </ul>
      </div>

      <div class="col-md-4">
        <h5 class="text-white fw-bold">Contact Info</h5>
        <p class="text-white mb-1">ECR ROUNDANA, East Coast Rd, Puthur, Manjakollai, Nagapattinam, Tamil Nadu 611106</p>
        <p class="text-white mb-1">Phone: <a href="tel:+918056529291" class="text-white text-decoration-none">+91 8056529291</a></p>
        <p>Email: <a href="mailto:Cosmosports51@gmail.com" class="text-white text-decoration-none">Cosmosports51@gmail.com</a></p>
      </div>

    </div>

    <hr class="bg-secondary my-4">
    <div class="text-center">
      <p class="text-white mb-1">&copy; 2025 Sports Shop. All rights reserved.</p>
      <p class="text-white mb-0" style="font-size: 12px;">
        Designed by <a href="http://annaasilicontechnology.com/#/" target="_blank" class="text-white text-decoration-none">Annaa Silicon Technology Pvt. Ltd.</a>
      </p>
    </div>
  </div>
</footer>



</body>
</html>

 